import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BbsRegister.css";
import Swal from "sweetalert2";
import axios from "axios";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import Editor from "../../../../components/Dashboard/Editor";

function BbsRegister() {
  // 초기 게시글 데이터 설정
  const initialBbsData = {
    title: "",
    contents: "",
    gubun: "C", //community
  };

  // 게시글 데이터 및 페이지 이동 함수
  const [bbsData, setBBSData] = useState({ ...initialBbsData });
  const navigate = useNavigate();

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/bbs`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  // 제목 변경 시 호출되는 함수
  const titleChange = (e) => {
    const { name, value } = e.target;
    setBBSData({
      ...bbsData,
      [name]: value,
    });
  };

  // 파일 변경 시 호출되는 함수
  const fileChange = (e) => {
    const file = e.target.files[0];
  };

  // 게시글 등록 페이지로 이동하는 함수
  const navigateToNoticePage = () => {
    navigate("/", { state: { setActiveMenu: "게시판", tabFlag: "커뮤니티" } });
  };

  // 에디터 ref 선언
  const editorRef = useRef(null);

  // 게시글 저장 함수
  const saveNotice = async () => {
    let updatedContents = bbsData.contents;

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updatedContents = html;
    }

    const fileInput = document.getElementById("noticeRegFileInputId").files[0];

    if (bbsData.title === "") {
      swalWarningFunction("제목을 입력하세요.");
      return;
    }

    if (updatedContents === "" || updatedContents === "<p><br></p>") {
      swalWarningFunction("게시글 내용을 작성해주세요.");
      return;
    }

    const formNoticeData = new FormData();
    formNoticeData.append("title", bbsData.title);
    formNoticeData.append("contents", updatedContents);
    formNoticeData.append("gubun", "C");

    if (fileInput !== undefined) {
      formNoticeData.append("files", fileInput);
    }

    try {
      const response = await axios.post(`${API_SERVER_URL}/create/${userId}`, formNoticeData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });

      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "게시글이 등록되었습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        }).then(() => {
          navigateToNoticePage();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "게시글 등록 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error Creating BBS:", error);

      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "게시글 등록 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  //sweetalert warning 함수
  const swalWarningFunction = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  return (
    <div className="bbs-register-content-container">
      <div className="bbs-detail-content-option-container">
        <input type="text" id="noticeTitleId" name="title" value={bbsData.title} onChange={titleChange} placeholder="제목을 입력해 주세요." />
      </div>
      <div className="bbs-detail-content-option-container-fileInput">
        <label>첨부파일: </label>
        <input type="file" id="noticeRegFileInputId" name="noticeRegFileInput" onChange={fileChange} style={{ border: "0px" }} />
      </div>
      <div className="bbs-reg-quill-container">
        <Editor ref={editorRef} readOnly={false} initialHTML={bbsData.contents} />
      </div>
      <div className="bbs-register-button-container">
        <button style={{ backgroundColor: "#333" }} onClick={saveNotice}>
          저장
        </button>
        <button onClick={navigateToNoticePage}>목록</button>
      </div>
    </div>
  );
}

export default BbsRegister;
